module.exports = __webpack_public_path__ + "static/space_Space_Asset-df6a9294596538dd5ac944f569ef1c4f.svg";